import React, { useEffect } from 'react';

import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import './button.scss';

import { ArrowIconRight, CloseIcon } from '../../Atoms/Icons/Icons'

/**
 * Primary UI component for user interaction
 */
export const Button = ({ inactive, primary, size, label, icon, link, customClass, onClickEvent, ...props }) => {
  const mode = primary ? 'btn--primary' : 'btn--secondary';
  const active = inactive ? 'inactive' : null;
  const setIcon = (icon) => {
    let Icon = '';
    icon === "plus" && (
      Icon = <CloseIcon customCLass="icon_plus" />
    )
    icon === "arrowright" && (
      Icon = <ArrowIconRight customCLass="icon_arrowright" />
    )
    return Icon;
  };
  useEffect(() => {

    window.addEventListener("load", e => {
      document.querySelectorAll('a[href]').forEach(a => {
        if (location.hostname == new URL(a.href).hostname)
          return;

        a.target = "_blank";
      });
    });
  }, []);

  if (link) {
    if (icon === "arrowright") {
      return (
        <>
          {
            props.target === '_blank' ? (
              <a
                href={link}
                className={['btn', `btn--${size}`, mode, active, customClass].join(' ')}
                {...props}
                onClick={onClickEvent ? (e) => onClickEvent(e) : undefined}
              >
                {label}
                {
                  icon && (setIcon(icon))
                }
              </a>
            ) : (
              <Link
                to={link}
                className={['btn', `btn--${size}`, mode, active, customClass].join(' ')}
                {...props}
                onClick={onClickEvent ? (e) => onClickEvent(e) : undefined}
              >
                {
                  icon && (setIcon(icon))
                }
                {label}
              </Link>
            )
          }
        </>
      );
    }
    else {
      return (
        <>
          {
            props.target === '_blank' ? (
              <a
                href={link}
                className={['btn', `btn--${size}`, mode, active, customClass].join(' ')}
                {...props}
                onClick={onClickEvent ? (e) => onClickEvent(e) : undefined}
              >
                {label}
                {
                  icon && (setIcon(icon))
                }
              </a>
            ) : (
              <Link
                to={link}
                className={['btn', `btn--${size}`, mode, active, customClass].join(' ')}
                {...props}
                onClick={onClickEvent ? (e) => onClickEvent(e) : undefined}
              >
                {label}
                {
                  icon && (setIcon(icon))
                }
              </Link>
            )
          }
        </>
      );
    }
  } else {
    if (icon === "arrowright") {
      return (
        <button
          className={['btn', `btn--${size}`, mode, active, customClass].join(' ')}
          {...props}
          onClick={onClickEvent ? (e) => onClickEvent(e) : undefined}
        >
          {
            icon && (setIcon(icon))
          }
          {label}
        </button>
      );
    }
    else {
      return (
        <button
          className={['btn', `btn--${size}`, mode, active, customClass].join(' ')}
          onClick={onClickEvent ? (e) => onClickEvent(e) : undefined}
          {...props}
        >
          {label}
          {
            icon && (setIcon(icon))
          }
        </button>
      );
    }

  }
};

Button.propTypes = {
  /**
   * Is this the principal call to action on the page?
   */
  primary: PropTypes.bool,
  /**
   * What background color to use
   */
  /**
   * How large should the button be?
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * Button contents
   */
  label: PropTypes.string.isRequired,

};

Button.defaultProps = {
  primary: false,
  size: 'medium',
  label: 'Button'
};
